module.exports = __webpack_public_path__ + "in-progress.png";